import './NewPassword.scss';

import { PASSWORD } from '@sonar-software/sonar-ts-constants';

import { Checkbox, Input, InputProps, Popover } from 'antd';
import React, { useCallback, useMemo, useState } from 'react';

type PasswordValidator = {
	label: string;
	validate: (value: string) => boolean;
};

const validators: PasswordValidator[] = [
	{
		label: PASSWORD.REQUIREMENT_UPPERCASE,
		validate: (value: string) => (/[A-Z]/u).test(value)
	},
	{
		label: PASSWORD.REQUIREMENT_LOWERCASE,
		validate: (value: string) => (/[a-z]/u).test(value)
	},
	{
		label: PASSWORD.REQUIREMENT_NUMERIC,
		validate: (value: string) => (/.*\d/u).test(value)
	},
	{
		label: PASSWORD.REQUIREMENT_NONALPHANUMERIC,
		validate: (value: string) => (/.*\W/u).test(value)
	},
	{
		label: PASSWORD.REQUIREMENT_LENGTH,
		validate: (value: string) => value.length >= 8
	}
];

function getValidatorResults(password: string) {
	return (
		<> { validators.map(({ label, validate }) => {
			const isValid = validate(password);

			return (
				<p
					className={ isValid ? 'valid' : '' }
					key={ label }>
					<Checkbox checked={ isValid }>{ label }</Checkbox>
				</p>
			);
		}) }
		</>
	);
}

export interface NewPasswordProps extends InputProps {
    disabled?: boolean;
	id?: string;
	name?: string;
}

export const NewPassword: React.FC<NewPasswordProps> = ({ disabled, id, name = 'password', ...props }) => {
	const [ password, setPassword ] = useState('');

	const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
		const value = e.target.value?.trim() ?? '';

		const formProps = props as Partial<InputProps>;

		if (formProps.onChange) {
			e.persist();
			formProps.onChange(e);
		}

		setPassword(value);
	}, [ props ]);

	const validatorResults = useMemo(() => getValidatorResults(password), [ password ]);

	return (
		<Popover
			classNames={ { root: 'new-password-validation' } }
			content={ validatorResults }
			placement='right'
			trigger='focus'>
			<Input.Password
				{ ...props }
				disabled={ disabled }
				id={ id }
				name={ name }
				onChange={ handleChange }
				placeholder={ PASSWORD.PLACEHOLDER_NEW }
				type='text'
				value={ password } />
		</Popover>
	);
};
